import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero text-center">
        <h1 className="about-hero-title">About PupNet</h1>
        <p className="about-hero-subtitle">
          PupNet is a collaborative blog for dog lovers. Every dog is special,
          and we have a soft spot for rare breeds. There are over 400 breeds in
          the world. How many can you find? From Golden Retrievers at the park
          to that rare Azawakh you never expected to see, the rarer the find,
          the sweeter the victory.
        </p>
      </section>

      {/* How It Works */}
      <section className="about-section">
        <h2 className="section-title text-center about-section-title">How It Works</h2>
        <Row className="g-4 mt-2">
          <Col xs={6} md={3}>
            <div className="about-step-card text-center">
              <div className="about-step-icon">
                <i className="bi bi-search"></i>
              </div>

              <h5 className="about-step-label">Spot a Pup</h5>
              <p className="about-step-desc">
                See a cute dog on your walk, at the park, or out and about? Time to capture the moment.
              </p>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="about-step-card text-center">
              <div className="about-step-icon">
                <i className="bi bi-camera"></i>
              </div>

              <h5 className="about-step-label">Snap a Photo</h5>
              <p className="about-step-desc">
                Use PupNet's built-in camera or upload a photo from your gallery to save the sighting.
              </p>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="about-step-card text-center">
              <div className="about-step-icon">
                <i className="bi bi-tags"></i>
              </div>

              <h5 className="about-step-label">Tag the Breed</h5>
              <p className="about-step-desc">
                Identify the breed from our encyclopedia of hundreds of breeds.
              </p>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="about-step-card text-center">
              <div className="about-step-icon">
                <i className="bi bi-share"></i>
              </div>

              <h5 className="about-step-label">Share It</h5>
              <p className="about-step-desc">
                Post your pup for others to see, react to, and celebrate. Every dog deserves the spotlight.
              </p>
            </div>
          </Col>
        </Row>
      </section>

      {/* Features */}
      <section className="about-section">
        <h2 className="section-title text-center about-section-title">Features</h2>
        <Row className="g-4 mt-2">
          <Col md={6} lg={4}>
            <div className="about-feature-card">
              <div className="about-feature-icon">
                <i className="bi bi-book"></i>
              </div>
              <div>
                <h5 className="about-feature-title">Breed Encyclopedia</h5>
                <p className="about-feature-desc">
                  Browse hundreds of dog breeds with photos, descriptions, and fun facts. Learn something new about your favorite breeds.
                </p>
              </div>
            </div>
          </Col>
          <Col md={6} lg={4}>
            <div className="about-feature-card">
              <div className="about-feature-icon">
                <i className="bi bi-collection"></i>
              </div>
              <div>
                <h5 className="about-feature-title">Community Feed</h5>
                <p className="about-feature-desc">
                  Scroll through an endless stream of adorable pups posted by dog lovers around the world. Your daily dose of cute, guaranteed.
                </p>
              </div>
            </div>
          </Col>
          <Col md={6} lg={4}>
            <div className="about-feature-card">
              <div className="about-feature-icon">
                <i className="bi bi-star"></i>
              </div>
              <div>
                <h5 className="about-feature-title">Pup of the Day</h5>
                <p className="about-feature-desc">
                  Every day, one special pup gets featured front and center. Will your pup be the next star?
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </section>

      {/* Community Section */}
      <section className="about-community text-center">
        <h2 className="about-community-title">Join the Hunt</h2>
        <p className="about-community-text">
          Thousands of breed hunters are already on the quest, logging sightings
          from cities and trails around the world. Start your collection today
          and see how many breeds you can discover. The ultimate goal? Catch
          'em all.
        </p>
        <div className="about-cta-buttons">
          <Link to="/register">
            <Button variant="primary" size="lg" className="me-3 mb-2">
              Sign Up
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline-primary" size="lg" className="mb-2">
              Start Exploring
            </Button>
          </Link>
        </div>
        <p className="about-creators">
          Created by{' '}
          <a href="https://www.instagram.com/caffeinatedclaire" target="_blank" rel="noopener noreferrer">
            @caffeinatedclaire
          </a>
          {' & '}
          <a href="https://www.instagram.com/gleitz" target="_blank" rel="noopener noreferrer">
            @gleitz
          </a>
        </p>
      </section>
    </div>
  );
};

export default AboutPage;
